import { createUseStyles } from 'react-jss'
import { colors, fonts } from '#base/js/variables.style'

export const style = {
  text: {
    fill: colors.brandDark,
    font: fonts.lato,
    fontSize: 11,
    textAnchor: 'middle'
  }
}

export const useStyles = createUseStyles(style)
